import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_edit_search_btn = _resolveComponent("edit-search-btn")!

  return (_ctx.postSearch)
    ? (_openBlock(), _createBlock(_component_edit_search_btn, _mergeProps({
        key: 0,
        "post-search-id": _ctx.postSearch.id,
        title: "Manage Flags"
      }, _ctx.$attrs), null, 16, ["post-search-id"]))
    : _createCommentVNode("", true)
}